
import React from 'react';
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '@/components/ui/table';

const EnterpriseBlueprint = () => {
  const phases = [
    {
      name: "Strategic Discovery",
      duration: "2 weeks",
      outcomes: "Use‑case prioritization, ROI model, executive alignment"
    },
    {
      name: "Pilot & Proof of Value",
      duration: "4-6 weeks",
      outcomes: "Deployed agent(s) hitting target KPIs in a controlled environment"
    },
    {
      name: "Enterprise Rollout",
      duration: "6‑12 months",
      outcomes: "Production‑grade agent platform, CoE handover, governance framework"
    },
    {
      name: "Continuous Optimization",
      duration: "Ongoing",
      outcomes: "Quarterly RL upgrades, cost optimization, emergent use‑case scouting"
    }
  ];

  return (
    <section className="py-12">
      <Card className="border-primary/20">
        <CardHeader>
          <CardTitle className="text-2xl">Consulting Engagement Blueprint</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Phase</TableHead>
                <TableHead>Duration</TableHead>
                <TableHead>Outcomes</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {phases.map((phase) => (
                <TableRow key={phase.name}>
                  <TableCell className="font-medium">{phase.name}</TableCell>
                  <TableCell>{phase.duration}</TableCell>
                  <TableCell>{phase.outcomes}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </section>
  );
};

export default EnterpriseBlueprint;
